import React from 'react';
import AboutschoolCard from '../Aboutschool/AboutschoolCard';
import aboutschool from '../../assets/images/aboutschool.jpg';
import aimandobjective from '../../assets/images/aimandobjective.jpg';

const Acard = () => {
  return (
    <div className="aboutschool-container">

      <div className="row justify-content-center">

        <div className="col-12 d-flex justify-content-center mb-4">
          <AboutschoolCard
            header="ABOUT SCHOOL"
            image={aboutschool}
            descr1="North Point Children’s Academy is a Co-Educational Day English medium School from Play Group to Class XIIth. Located in Garhi Cantt Dehradun with excellent academic records."
            descr2="The main objective of the Academy is to impart quality education & prepare students for exams held by the Council for the Indian School Certificate Examinations, New Delhi keeping Indian Cultural background so that the foundation of the young ones could properly be laid to enable them to sail smoothly in their further studies when they pass out from the Institution. Besides imparting quality education, particular attention is paid to extra co curricular activities to develop their moral, discipline, good habits and cultivate good behavior and respectable attitude towards their elders."
          />
        </div>

        <div className="col-12 d-flex justify-content-center mb-4">
          <AboutschoolCard
            header="AIMS & OBJECTIVES"
            image={aimandobjective}
            descr1="The main aim of the school is to give the best to the students with the available resources who are entrusted to our care by following the modern education lines and to inculcate in them the integrity of character, leadership, responsibility so as to become worthy citizens."
            descr2="The medium of Instruction in the Academy is English and special stress is laid to encourage the children to converse in English."
          />
        </div>

      </div>

    </div>
  );
};

export default Acard;